/* Ontwerpstudio PV-waarschuwingsstickers 74 x 52 mm voor ricardwebshop.nl.

   De canvas-tekenroute spiegelt de druk: dezelfde opbouw, dezelfde maten en
   dezelfde afbreekregels als herteken.py en het drukvel. Wijzigt daar iets,
   dan hier ook.

   Opbouw van onder naar boven: geel vlak, zwart kader, het logo, de drie
   tekstblokken. De preview toont de sticker op eindformaat; de afloop zit
   alleen in het drukbestand.

   Geel en zwart liggen vast, want dat is de waarschuwingskleur. Alleen de
   tekstkleur is vrij. */
(function () {
  "use strict";

  var GEO = window.PV74_GEO;
  var ASSETS = window.PV74_ASSETS || {};
  var VARIANTEN = window.PV74_VARIANTEN || [];
  var canvas = document.getElementById("pv74-canvas");
  if (!GEO || !canvas) { return; }

  var ctx = canvas.getContext("2d");
  var STICKER_MM = GEO.sticker.netto_mm;      // [74, 52]
  var RADIUS_MM = GEO.sticker.radius_mm;
  var MARGE_MM = 5;                            // witruimte rondom in de preview
  var TEKST = GEO.tekst;
  var KADER = GEO.kader;
  var PT_NAAR_MM = 25.4 / 72;

  var LOGISCH_B = canvas.width;
  var LOGISCH_H = canvas.height;
  var DPR = 1;
  var PX_PER_MM = LOGISCH_B / (STICKER_MM[0] + 2 * MARGE_MM);

  // Hoeveel tekstvakken: uit de geometrie, maar nooit meer dan er in de HTML
  // staan. Lopen die twee uiteen, dan is er een half doorgevoerde wijziging en
  // dat hoort op te vallen in plaats van stil mis te gaan.
  var VAKKEN = GEO.tekst.aantal_vakken || 3;
  var IN_HTML = document.querySelectorAll('[id^="pv74-tekst-"][id$="-schaal"]').length;
  if (IN_HTML && IN_HTML !== VAKKEN) {
    console.warn("pv74-studio: " + VAKKEN + " tekstvakken in geometrie.json, "
                 + IN_HTML + " in de sectie. Er wordt met " +
                 Math.min(VAKKEN, IN_HTML) + " gewerkt.");
    VAKKEN = Math.min(VAKKEN, IN_HTML);
  }

  var VOLGORDE = Object.keys(GEO.varianten);
  var START = window.PV74_START;
  if (VOLGORDE.indexOf(START) < 0) { START = VOLGORDE[0]; }

  var state = {
    variant: START,
    teksten: [],
    logoUrl: "",
    logoBeeld: null,
    logo: { x: 0.5, y: 0.26, breedte: 0.34 },
    variantId: VARIANTEN.length ? VARIANTEN[0].id : null,
    snapshotUrl: "",
    bezig: false
  };

  var sleep = null;

  /* ---------- hulpjes ---------- */

  function mmx(v) { return v * PX_PER_MM; }
  function klem(v, laag, hoog) { return Math.max(laag, Math.min(hoog, v)); }

  function laadBeeld(url, klaar) {
    var img = new Image();
    img.crossOrigin = "anonymous";
    img.onload = function () { klaar(img); };
    img.onerror = function () { klaar(null); };
    img.src = url;
  }

  function afgerondPad(t, x, y, b, h, r) {
    r = Math.min(r, b / 2, h / 2);
    t.beginPath();
    t.moveTo(x + r, y);
    t.lineTo(x + b - r, y);
    t.quadraticCurveTo(x + b, y, x + b, y + r);
    t.lineTo(x + b, y + h - r);
    t.quadraticCurveTo(x + b, y + h, x + b - r, y + h);
    t.lineTo(x + r, y + h);
    t.quadraticCurveTo(x, y + h, x, y + h - r);
    t.lineTo(x, y + r);
    t.quadraticCurveTo(x, y, x + r, y);
    t.closePath();
  }

  /* ---------- de gedeelde tekstregels: gelijk aan herteken.py ---------- */

  /** Het korps in punten. Nooit onder de bodem uit geometrie.json (6 pt): dat
      is wat de machine nog scherp drukt, en lager gaan we niet. */
  function korpsPt(schaal) {
    schaal = klem(schaal, TEKST.schaal_min, TEKST.schaal_max);
    return Math.max(TEKST.bodem_pt, TEKST.basis_pt * schaal);
  }

  /** De breedte waarbinnen tekst mag staan: binnen het kader, min de marge. */
  function ruimteMm() {
    return KADER.binnen_mm[2] - KADER.binnen_mm[0] - 2 * TEKST.marge_mm;
  }

  function zetFont(t, korps) {
    t.font = TEKST.gewicht + " " + mmx(korps * PT_NAAR_MM).toFixed(2) + "px " + TEKST.font_stapel;
  }

  function breedteMm(t, regel, korps) {
    zetFont(t, korps);
    return t.measureText(regel).width / PX_PER_MM;
  }

  /** Breekt op woorden af. Een regeleinde in de tekst is HARD: daar breekt hij
      altijd, zodat de klant de afbreking zelf in de hand houdt. */
  function breekAf(t, tekst, korps) {
    var ruimte = ruimteMm();
    var uit = [];
    (tekst || "").split("\n").forEach(function (stuk) {
      var woorden = stuk.split(/\s+/).filter(Boolean);
      if (!woorden.length) { return; }
      var huidig = woorden[0];
      for (var i = 1; i < woorden.length; i++) {
        var poging = huidig + " " + woorden[i];
        if (breedteMm(t, poging, korps) <= ruimte) {
          huidig = poging;
        } else {
          uit.push(huidig);
          huidig = woorden[i];
        }
      }
      uit.push(huidig);
    });
    return uit;
  }

  /** Past elk los woord nog op een regel? Zo niet, dan loopt de tekst over de
      rand en moet de klant hem inkorten; wij verkleinen niet onder de bodem. */
  function pastHet(tekst, korps) {
    var ruimte = ruimteMm();
    var woorden = (tekst || "").split(/\s+/).filter(Boolean);
    for (var i = 0; i < woorden.length; i++) {
      if (breedteMm(ctx, woorden[i], korps) > ruimte) { return false; }
    }
    return true;
  }

  function blokMaten(t, regels, korps) {
    if (!regels.length) { return { breedte: 0, hoogte: 0 }; }
    var breed = 0;
    regels.forEach(function (r) { breed = Math.max(breed, breedteMm(t, r, korps)); });
    var regelhoogte = korps * TEKST.regelafstand * PT_NAAR_MM;
    return {
      breedte: breed,
      hoogte: regelhoogte * (regels.length - 1) + korps * PT_NAAR_MM
    };
  }

  /** Houdt het midden van een element binnen het zwarte kader. Zelfde klem als
      binnen_kader() in herteken.py, en hij hoort ook bij het TEKENEN te
      gelden: wordt een tekst groter of langer, dan schuift hij vanzelf terug
      naar binnen, precies zoals de druk hem zal zetten. */
  function binnenKader(midden, maatMm, as) {
    var b = KADER.binnen_mm;
    var van = as === "x" ? b[0] : b[1];
    var tot = as === "x" ? b[2] : b[3];
    var sticker = as === "x" ? STICKER_MM[0] : STICKER_MM[1];
    var half = maatMm / 2;
    var laag = (van + half) / sticker, hoog = (tot - half) / sticker;
    return laag > hoog ? 0.5 : klem(midden, laag, hoog);
  }

  /* ---------- tekenen ---------- */

  function tekenOp(t, offsetMm) {
    var dx = mmx(offsetMm), dy = mmx(offsetMm);
    var breedte = mmx(STICKER_MM[0]), hoogte = mmx(STICKER_MM[1]);

    t.save();
    afgerondPad(t, dx, dy, breedte, hoogte, mmx(RADIUS_MM));
    t.clip();

    // 1. geel vlak
    t.fillStyle = GEO.sticker.vlak_kleur;
    t.fillRect(dx, dy, breedte, hoogte);

    // 2. het zwarte kader: een streek op de gemeten middenlijn
    var m = KADER.midden_mm;
    t.strokeStyle = KADER.kleur;
    t.lineWidth = mmx(KADER.lijndikte_mm);
    t.lineJoin = "miter";
    afgerondPad(t, dx + mmx(m[0]), dy + mmx(m[1]),
                mmx(m[2] - m[0]), mmx(m[3] - m[1]), mmx(KADER.radius_mm));
    t.stroke();

    // 3. het logo
    if (state.logoBeeld) {
      var r = logoRechthoek();
      t.drawImage(state.logoBeeld, dx + r.x, dy + r.y, r.b, r.h);
    }

    // 4. de tekstblokken
    t.textBaseline = "top";
    state.teksten.forEach(function (tekst) {
      var inhoud = (tekst.tekst || "").trim();
      if (!inhoud) { return; }
      var korps = korpsPt(tekst.schaal);
      var regels = breekAf(t, inhoud, korps);
      var maten = blokMaten(t, regels, korps);
      var mx = binnenKader(tekst.x, maten.breedte, "x");
      var my = binnenKader(tekst.y, maten.hoogte, "y");
      var boven = my * STICKER_MM[1] - maten.hoogte / 2;
      var regelhoogte = korps * TEKST.regelafstand * PT_NAAR_MM;
      zetFont(t, korps);
      t.fillStyle = tekst.kleur;
      regels.forEach(function (regel, n) {
        var b = t.measureText(regel).width;
        t.fillText(regel,
                   dx + mx * breedte - b / 2,
                   dy + mmx(boven + n * regelhoogte));
      });
    });

    t.restore();

    // dunne grijze snijrand zodat de klant ziet waar de sticker ophoudt
    t.save();
    afgerondPad(t, dx, dy, breedte, hoogte, mmx(RADIUS_MM));
    t.strokeStyle = "rgba(0,0,0,0.25)";
    t.lineWidth = 1;
    t.stroke();
    t.restore();
  }

  function teken() {
    ctx.setTransform(1, 0, 0, 1, 0, 0);
    ctx.clearRect(0, 0, canvas.width, canvas.height);
    ctx.setTransform(DPR, 0, 0, DPR, 0, 0);
    ctx.fillStyle = "#f6f6f6";
    ctx.fillRect(0, 0, LOGISCH_B, LOGISCH_H);
    tekenOp(ctx, MARGE_MM);
  }

  /* ---------- posities en slepen ---------- */

  function logoRechthoek() {
    if (!state.logoBeeld) { return null; }
    var breedte = mmx(STICKER_MM[0]), hoogte = mmx(STICKER_MM[1]);
    var b = klem(state.logo.breedte, GEO.logo.breedte_min, GEO.logo.breedte_max) * breedte;
    var h = b * (state.logoBeeld.naturalHeight / state.logoBeeld.naturalWidth);
    var mx = binnenKader(state.logo.x, b / PX_PER_MM, "x");
    var my = binnenKader(state.logo.y, h / PX_PER_MM, "y");
    return { x: mx * breedte - b / 2, y: my * hoogte - h / 2, b: b, h: h };
  }

  function tekstRechthoek(tekst) {
    var inhoud = (tekst.tekst || "").trim();
    if (!inhoud) { return null; }
    var breedte = mmx(STICKER_MM[0]), hoogte = mmx(STICKER_MM[1]);
    var korps = korpsPt(tekst.schaal);
    var maten = blokMaten(ctx, breekAf(ctx, inhoud, korps), korps);
    var mx = binnenKader(tekst.x, maten.breedte, "x");
    var my = binnenKader(tekst.y, maten.hoogte, "y");
    return {
      x: mx * breedte - mmx(maten.breedte) / 2,
      y: my * hoogte - mmx(maten.hoogte) / 2,
      b: mmx(maten.breedte),
      h: mmx(maten.hoogte)
    };
  }

  function punt(evt) {
    var vak = canvas.getBoundingClientRect();
    // van schermpixels naar de logische tekenruimte. Niet canvas.width
    // gebruiken: die telt de ECHTE pixels, en op een retinascherm zijn dat er
    // twee keer zoveel. Dan wees elke muisklik naar de verkeerde plek.
    var schaal = LOGISCH_B / vak.width;
    return {
      x: (evt.clientX - vak.left) * schaal - mmx(MARGE_MM),
      y: (evt.clientY - vak.top) * schaal - mmx(MARGE_MM)
    };
  }

  function inRechthoek(p, r, speling) {
    if (!r) { return false; }
    speling = speling || 4;
    return p.x >= r.x - speling && p.x <= r.x + r.b + speling &&
           p.y >= r.y - speling && p.y <= r.y + r.h + speling;
  }

  function pakOp(p) {
    // van boven naar beneden in tekenvolgorde: eerst de teksten, dan het logo
    for (var i = state.teksten.length - 1; i >= 0; i--) {
      if (inRechthoek(p, tekstRechthoek(state.teksten[i]))) {
        return { soort: "tekst", index: i };
      }
    }
    if (inRechthoek(p, logoRechthoek())) { return { soort: "logo" }; }
    return null;
  }

  /** Binnen het kader houden. Buiten het kader ligt de gele rand en daar hoort
      geen tekst of logo; wat over de snijlijn steekt wordt bovendien
      weggeknipt. */
  function klemInKader(doel, vak) {
    doel.x = binnenKader(doel.x, vak ? vak.b / PX_PER_MM : 0, "x");
    doel.y = binnenKader(doel.y, vak ? vak.h / PX_PER_MM : 0, "y");
  }

  function verplaats(greep, p) {
    var breedte = mmx(STICKER_MM[0]), hoogte = mmx(STICKER_MM[1]);
    var doel = greep.soort === "logo" ? state.logo : state.teksten[greep.index];
    doel.x = (p.x - greep.grijpX) / breedte;
    doel.y = (p.y - greep.grijpY) / hoogte;
    klemInKader(doel, greep.soort === "logo" ? logoRechthoek()
                                             : tekstRechthoek(state.teksten[greep.index]));
  }

  canvas.addEventListener("pointerdown", function (evt) {
    var p = punt(evt);
    var greep = pakOp(p);
    if (!greep) { return; }
    var breedte = mmx(STICKER_MM[0]), hoogte = mmx(STICKER_MM[1]);
    var doel = greep.soort === "logo" ? state.logo : state.teksten[greep.index];
    greep.grijpX = p.x - doel.x * breedte;
    greep.grijpY = p.y - doel.y * hoogte;
    sleep = greep;
    canvas.setPointerCapture(evt.pointerId);
    canvas.classList.add("is-slepend");
    evt.preventDefault();
  });

  canvas.addEventListener("pointermove", function (evt) {
    if (!sleep) {
      canvas.style.cursor = pakOp(punt(evt)) ? "grab" : "default";
      return;
    }
    verplaats(sleep, punt(evt));
    teken();
  });

  function laatLos(evt) {
    if (!sleep) { return; }
    sleep = null;
    canvas.classList.remove("is-slepend");
    if (evt && evt.pointerId !== undefined && canvas.hasPointerCapture(evt.pointerId)) {
      canvas.releasePointerCapture(evt.pointerId);
    }
  }
  canvas.addEventListener("pointerup", laatLos);
  canvas.addEventListener("pointercancel", laatLos);

  /* ---------- het paneel ---------- */

  function veld(n, achtervoegsel) {
    return document.getElementById("pv74-tekst-" + n + (achtervoegsel || ""));
  }

  function schaalNaarSchuif(schaal) {
    return Math.round((schaal - TEKST.schaal_min) /
                      (TEKST.schaal_max - TEKST.schaal_min) * 100);
  }

  function zetVariant(sleutel, behoudTekst) {
    var v = GEO.varianten[sleutel];
    if (!v) { return; }
    state.variant = sleutel;
    if (!behoudTekst) {
      state.teksten = v.startregels.slice(0, VAKKEN).map(function (r) {
        return { tekst: r.tekst, x: r.x, y: r.y, schaal: r.schaal, kleur: r.kleur };
      });
      state.teksten.forEach(function (tekst, i) {
        var invoer = veld(i + 1);
        if (invoer) { invoer.value = tekst.tekst; }
        var schuif = veld(i + 1, "-schaal");
        if (schuif) { schuif.value = String(schaalNaarSchuif(tekst.schaal)); }
        var kleur = veld(i + 1, "-kleur");
        if (kleur) { kleur.value = tekst.kleur; }
      });
    }
    merkVariantKnoppen();
    bijwerkenTekstmeldingen();
  }

  var variantKnoppen = document.querySelectorAll("[data-variant]");
  function merkVariantKnoppen() {
    variantKnoppen.forEach(function (k) {
      k.classList.toggle("is-actief", k.getAttribute("data-variant") === state.variant);
    });
  }
  variantKnoppen.forEach(function (knop) {
    knop.addEventListener("click", function () {
      var sleutel = knop.getAttribute("data-variant");
      if (!GEO.varianten[sleutel] || sleutel === state.variant) { return; }
      zetVariant(sleutel, false);
      teken();
    });
  });

  function bijwerkenTekstmeldingen() {
    state.teksten.forEach(function (tekst, i) {
      var el = veld(i + 1, "-melding");
      if (!el) { return; }
      var inhoud = (tekst.tekst || "").trim();
      var teLang = !pastHet(inhoud, korpsPt(tekst.schaal));
      var regels = inhoud ? breekAf(ctx, inhoud, korpsPt(tekst.schaal)).length : 0;
      if (teLang) {
        el.hidden = false;
        el.className = "pv74-tekstmelding is-fout";
        el.textContent = "Een woord in deze regel is te breed voor de sticker. "
          + "Kort het in of zet de tekst kleiner.";
      } else if (regels > 3) {
        el.hidden = false;
        el.className = "pv74-tekstmelding";
        el.textContent = "Deze tekst wordt " + regels + " regels. Dat kan, maar "
          + "kijk in het voorbeeld of het nog netjes staat.";
      } else {
        el.hidden = true;
      }
    });
  }

  function koppel(id, gebeurtenis, doe) {
    var el = document.getElementById(id);
    if (el) { el.addEventListener(gebeurtenis, function () { doe(el); teken(); }); }
    return el;
  }

  for (var n = 1; n <= VAKKEN; n++) {
    (function (index) {
      koppel("pv74-tekst-" + index, "input", function (el) {
        state.teksten[index - 1].tekst = el.value;
        bijwerkenTekstmeldingen();
      });
      koppel("pv74-tekst-" + index + "-schaal", "input", function (el) {
        state.teksten[index - 1].schaal = TEKST.schaal_min +
          (TEKST.schaal_max - TEKST.schaal_min) * (Number(el.value) / 100);
        bijwerkenTekstmeldingen();
      });
      koppel("pv74-tekst-" + index + "-kleur", "input", function (el) {
        state.teksten[index - 1].kleur = el.value;
      });
    })(n);
  }

  koppel("pv74-logo-schaal", "input", function (el) {
    state.logo.breedte = GEO.logo.breedte_min +
      (GEO.logo.breedte_max - GEO.logo.breedte_min) * (Number(el.value) / 100);
    klemInKader(state.logo, logoRechthoek());
  });

  /* ---------- logo uploaden ---------- */

  function toonLogoStatus(tekst, isFout) {
    var el = document.getElementById("pv74-logo-status");
    if (!el) { return; }
    el.textContent = tekst || "";
    el.classList.toggle("is-fout", !!isFout);
  }

  function toonFout(tekst) {
    var el = document.getElementById("pv74-foutmelding");
    if (!el) { return; }
    el.textContent = tekst || "";
    el.hidden = !tekst;
  }

  function kiesLogo(bestand) {
    if (!bestand) { return; }
    if (bestand.size > 8 * 1024 * 1024) {
      toonLogoStatus("Dit bestand is groter dan 8 MB.", true);
      return;
    }
    toonLogoStatus("Bezig met uploaden...");
    state.bezig = true;
    bijwerkenKnop();

    var lezer = new FileReader();
    lezer.onload = function () {
      laadBeeld(lezer.result, function (img) {
        if (img) {
          state.logoBeeld = img;
          klemInKader(state.logo, logoRechthoek());
          teken();
        }
      });
    };
    lezer.readAsDataURL(bestand);

    var fd = new FormData();
    fd.append("bestand", bestand);
    fetch(ASSETS.uploadUrl, { method: "POST", body: fd })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
      .then(function (res) {
        state.bezig = false;
        if (!res.ok || !res.j.url) {
          toonLogoStatus(res.j.fout || "Uploaden is niet gelukt.", true);
          state.logoUrl = "";
        } else {
          state.logoUrl = res.j.url;
          toonLogoStatus("Logo geplaatst. Sleep het in het voorbeeld op zijn plek.");
        }
        bijwerkenKnop();
      })
      .catch(function () {
        state.bezig = false;
        state.logoUrl = "";
        toonLogoStatus("Uploaden is niet gelukt. Probeer het nog eens.", true);
        bijwerkenKnop();
      });
  }

  var logoInvoer = document.getElementById("pv74-logo-invoer");
  if (logoInvoer) {
    logoInvoer.addEventListener("change", function () { kiesLogo(logoInvoer.files[0]); });
  }
  var dropzone = document.getElementById("pv74-dropzone");
  if (dropzone) {
    ["dragenter", "dragover"].forEach(function (naam) {
      dropzone.addEventListener(naam, function (e) {
        e.preventDefault(); dropzone.classList.add("is-actief");
      });
    });
    ["dragleave", "drop"].forEach(function (naam) {
      dropzone.addEventListener(naam, function (e) {
        e.preventDefault(); dropzone.classList.remove("is-actief");
      });
    });
    dropzone.addEventListener("drop", function (e) {
      if (e.dataTransfer && e.dataTransfer.files.length) {
        kiesLogo(e.dataTransfer.files[0]);
      }
    });
  }

  var logoWeg = document.getElementById("pv74-logo-weg");
  if (logoWeg) {
    logoWeg.addEventListener("click", function () {
      state.logoUrl = ""; state.logoBeeld = null;
      if (logoInvoer) { logoInvoer.value = ""; }
      toonLogoStatus("");
      teken();
    });
  }

  /* ---------- aantal en winkelwagen ---------- */

  function euro(centen) {
    return "€ " + (centen / 100).toFixed(2).replace(".", ",");
  }

  function vulAantallen() {
    var keuze = document.getElementById("pv74-aantal");
    if (!keuze || !VARIANTEN.length) { return; }
    VARIANTEN.forEach(function (v) {
      var optie = document.createElement("option");
      optie.value = String(v.id);
      var stuks = parseInt(v.titel, 10);
      optie.textContent = v.titel + " - " + euro(v.prijs) +
        (stuks ? " (" + euro(v.prijs / stuks) + " per sticker)" : "");
      keuze.appendChild(optie);
    });
    keuze.value = String(state.variantId);
    keuze.addEventListener("change", function () {
      state.variantId = Number(keuze.value);
      toonPrijs();
    });
    toonPrijs();
  }

  function toonPrijs() {
    var el = document.getElementById("pv74-prijs");
    var variant = VARIANTEN.filter(function (v) { return v.id === state.variantId; })[0];
    if (el && variant) { el.textContent = euro(variant.prijs); }
  }

  function bijwerkenKnop() {
    var knop = document.getElementById("pv74-toevoegen");
    if (!knop) { return; }
    knop.disabled = state.bezig;
    knop.textContent = state.bezig ? "Even geduld..." : "In winkelwagen";
  }

  function tekstOpmaak(tekst) {
    return JSON.stringify({
      x: Number(tekst.x.toFixed(4)),
      y: Number(tekst.y.toFixed(4)),
      schaal: Number(tekst.schaal.toFixed(3)),
      kleur: tekst.kleur
    });
  }

  function snapshotBlob(klaar) {
    var kopie = document.createElement("canvas");
    kopie.width = LOGISCH_B * DPR;
    kopie.height = LOGISCH_H * DPR;
    var t = kopie.getContext("2d");
    t.setTransform(DPR, 0, 0, DPR, 0, 0);
    t.fillStyle = "#ffffff";
    t.fillRect(0, 0, LOGISCH_B, LOGISCH_H);
    var echt = ctx;
    ctx = t;                       // measureText moet op dezelfde context
    tekenOp(t, MARGE_MM);
    ctx = echt;
    kopie.toBlob(function (blob) { klaar(blob); }, "image/png");
  }

  function voegToe() {
    toonFout("");
    if (!state.variantId) { toonFout("Kies eerst een aantal."); return; }
    var leeg = state.teksten.every(function (t) { return !(t.tekst || "").trim(); });
    if (leeg && !state.logoUrl) {
      toonFout("Zet er eerst een tekst of je logo op.");
      return;
    }
    state.bezig = true;
    bijwerkenKnop();

    snapshotBlob(function (blob) {
      var klaarZetten = function () {
        var fd = new FormData();
        fd.append("id", String(state.variantId));
        fd.append("quantity", "1");
        fd.append("properties[Sticker]", GEO.varianten[state.variant].naam);
        state.teksten.forEach(function (tekst, i) {
          var inhoud = (tekst.tekst || "").trim();
          fd.append("properties[Tekst " + (i + 1) + "]", inhoud.replace(/\n/g, " / "));
          fd.append("properties[_Tekst" + (i + 1) + "]", inhoud);
          fd.append("properties[_Tekst" + (i + 1) + "Opmaak]", tekstOpmaak(tekst));
          // de afbreking zoals de klant hem ZAG; de druk breekt zelf opnieuw af
          // en de keuring meldt het als dat anders uitpakt
          fd.append("properties[_Tekst" + (i + 1) + "Regels]",
                    inhoud ? breekAf(ctx, inhoud, korpsPt(tekst.schaal)).join("\n") : "");
        });
        fd.append("properties[_Variant]", state.variant);
        fd.append("properties[_LogoURL]", state.logoUrl || "");
        fd.append("properties[_LogoPositie]",
                  state.logoUrl ? JSON.stringify({
                    x: Number(state.logo.x.toFixed(4)),
                    y: Number(state.logo.y.toFixed(4))
                  }) : "");
        fd.append("properties[_LogoSchaal]",
                  state.logoUrl ? String(state.logo.breedte.toFixed(4)) : "");
        fd.append("properties[_SnapshotURL]", state.snapshotUrl || "");

        fetch("/cart/add.js", { method: "POST", body: fd })
          .then(function (r) {
            if (!r.ok) { throw new Error("winkelwagen"); }
            window.location.href = "/cart";
          })
          .catch(function () {
            state.bezig = false;
            bijwerkenKnop();
            toonFout("Toevoegen aan de winkelwagen lukte niet. Probeer het nog eens.");
          });
      };

      if (!blob || !ASSETS.uploadUrl) { klaarZetten(); return; }
      var fd = new FormData();
      fd.append("bestand", blob, "voorbeeld.png");
      fetch(ASSETS.uploadUrl, { method: "POST", body: fd })
        .then(function (r) { return r.json(); })
        .then(function (j) { state.snapshotUrl = j.url || ""; })
        .catch(function () { state.snapshotUrl = ""; })
        .then(klaarZetten);
    });
  }

  var knop = document.getElementById("pv74-toevoegen");
  if (knop) { knop.addEventListener("click", voegToe); }

  /* ---------- opstarten ---------- */

  function hiDPI() {
    // Alleen de scherpte: meer echte pixels, zelfde logische tekenruimte. De
    // CSS bepaalt hoe groot het canvas op het scherm staat.
    DPR = window.devicePixelRatio || 1;
    canvas.width = LOGISCH_B * DPR;
    canvas.height = LOGISCH_H * DPR;
    ctx.setTransform(DPR, 0, 0, DPR, 0, 0);
  }

  window.__pv74studio = { state: state, teken: teken, geo: GEO, breekAf: breekAf };

  hiDPI();
  zetVariant(START, false);
  vulAantallen();
  bijwerkenKnop();
  teken();

  // Arial Black kan nog laden; opnieuw tekenen zodra hij er is, anders staat
  // de eerste tekening met een vervangend lettertype en klopt de afbreking niet
  if (document.fonts && document.fonts.ready) {
    document.fonts.ready.then(function () {
      bijwerkenTekstmeldingen();
      teken();
    });
  }
})();
